import { css } from '@emotion/core';

import colors from '../config/colors';
import { mobileMediaQuery, orientationLandscape } from '../config/mediaQuery';


const appbar = css`
  ${mobileMediaQuery} {
    .menu-background {
      height: calc(100% - 80px);
      display: flex;
      flex-direction: column;
      position: absolute;
      z-index: 1002;
      background-color: white;
      overflow: scroll;
      width: 100vw;
    }
    .mobile-menu {
      width: 100vw;
      display: flex;
      flex-direction: column;
      padding: 20px;
      z-index: 500;
      & a {
        color: #000;
        font-family: Lato;
        font-size: 1em;
        font-weight: 400;
        line-height: 20px;
        letter-spacing: 0em;
        height: 44px;
        margin-bottom: 10px;
        display: flex;
        align-items: center;
      }
      & img {
        margin-right: 10px;
        height: 24px;
      }
    }
    .menu-logout {
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      & li {
        list-style: none;
      }
    }
    .logout-button {
      background-color: transparent;
      border: none;
      font-family: Lato;
      color: #CE1717;
      font-size: 1em;
      font-weight: 400;
      line-height: 20px;
      letter-spacing: 0em;
      & img {
        margin-right: 10px;
      }
      ${orientationLandscape} {
        padding-bottom: 40px;
      }
    }
    .appbar {
      overflow: hidden;
      background-color: ${colors.mobileGreen};
      position: relative;
      margin-right: auto;
      margin-left: auto;
      padding-left: 15px;
      padding-right: 15px;
      display: flex;
      justify-content: space-between;
      height: 80px;
      z-index: 1001;
    }
    .appbar a {
      color: white;
      padding: 14px 16px;
      text-decoration: none;
      font-size: 17px;
      display: block;
    }
    .appbar-cart {
      margin-right: 10px;
      background-color: transparent;
      background-image: none;
      border: 1px solid transparent;
      border-radius: 4px;
    }
    .cart-number {
      position: absolute;
      width: 18px;
      height: 18px;
      bottom: 12px;
      left: 12px;
      border-radius: 100px;
      background-color: #fff;
      color: ${colors.mobileGreen};
      font-size: 12px;
      font-weight: 500;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .cart-group {
      position: relative;
    }
    .menu-button  {
      background-color: transparent;
      background-image: none;
      border: 1px solid transparent;
      border-radius: 4px;
    }
    .app-title {
      display: flex;
      align-items: center;
      & a {
        font-family: Lato;
        font-size: 20px;
        font-weight: 700;
        line-height: 20px;
        letter-spacing: 0em;
        text-align: left;
      }
    }
    .appbar-button-group {
      display: flex;
    }
    .view-title {
      display: flex;
      align-items: center;
      font-family: Lato;
      font-size: 20px;
      font-weight: 700;
      letter-spacing: 0em;
      color: #fff;
    }
  }
`;

export { appbar };
